import React, {useState} from 'react';
import styled from 'styled-components';
import Button from '../UI/Button/Button';
import theme from '../../styles/theme';
import InputBoxWithMax from '../InputBoxWithMax/InputBoxWithMax';
import { amountBToS} from '../../helpers/utilities';
import { gsSetGlobalState, disableAsyncButton, showLoadingButton } from '../../helpers/global-state';
import { doWeNeedToGetAllowance, getCollateralBalance, getMaxApproval, isLoggedInMetamask, loadFixedProductMarketMaker , getChainBaseUrl} from '../../helpers/web3';
import { useToasts } from 'react-toast-notifications'
import Modal from '../../components/Modal/Modal';
import useModal from '../../hooks/useModal';
import configData from '../../config.json';
import { amountSToB, strToFixed } from '../../helpers/utilities'
import { removeLiquidity } from '../../helpers/fpmm'
import { useTranslation } from 'react-i18next';
const RemoveLiquidity = ({
  isShowing,
  toggleShow,
  globalState, 
  setGlobalState,
  userStats,
  setUserStats,
  market,
  setShowOverlay
}) => {
  const { t } = useTranslation();
  const [liquidity, setLiquidity] = useState('');
  const [liquiditySuccessHash, setLiquiditySuccessHash] = useState(false);
  const [showRemoveLiquidityModel, setShowRemoveLiquidityModel] = useState(false);
  const actionName = 'remove_liquidity';
  const { addToast } = useToasts();
  const isUserLoggedIn = isLoggedInMetamask(globalState);

  const getUserLiquidityShares = () => {
    return userStats.liquidity.liquidityShares;
  }

  const onMaxClicked  = (e) => {
    e.preventDefault();
    //ask them to connect if not connected 
    if(!isUserLoggedIn){
      addToast(
        t('connect_your_wallet_first'),
        { appearance: "warning" }
      );
      return 0;
    }
    setLiquidity(amountSToB(getUserLiquidityShares()));
  }

  const validate = () => {
    if(liquidity=="" || liquidity==0){
      addToast(
        t('market_page.enter_shares_you_want_to_remove'), 
        { appearance: "error" }
      );
      return 0;
    }

    const userShares = amountSToB(getUserLiquidityShares());
    if(liquidity > userShares){
      addToast(
        t('market_page.trying_to_remove_more_than_you_have'), 
        { appearance: "error" }
      );
      return 0;
    }

    return 1;
  }

  const beforeSend = () => {
    setShowOverlay(true);
  }

  const afterSend = () => {
    setLiquidity("")
    setShowOverlay(false);
  }

  const onRemoveLiquidityError = (error) => {
    addToast(
      error.message, 
      { appearance: "error" }
    );  
    afterSend();
  }

  const onTransactionHash = (hash) => {
    setLiquiditySuccessHash(hash);
    afterSend();
  }

  const onConfirmation = (confirmationNumber, receipt) => {
    if(confirmationNumber==configData.SHOW_RESULT_AFTER_NTH_CONFIRMATION){
      addToast(
        t('market_page.liquidity_positions_updated'), 
        { appearance: "success" }
      );
      setUserStats();
    }
  }

  const removeFunding = async () => {
    try{
      const from = globalState.currentAddress;
      const liquidityToBePulled = amountBToS(liquidity);
      const argRemoveLiquidity = {
        globalState, 
        market, 
        from, 
        liquidityToBePulled,
        onConfirmation,
        onError : onRemoveLiquidityError,
        onTransactionHash
      }

      await removeLiquidity(argRemoveLiquidity);
    }catch(error){
      throw error;
    }
  }

  const validateAndRemoveFunding = async (event) => {
    event.preventDefault();
    if(!validate()) return 0;

    //ask them to connect if not connected
    if(!isLoggedInMetamask(globalState)){
      addToast(
        t('connect_your_wallet_first'), 
        { appearance: "warning" }
      );
      return 0;
    }

    setShowRemoveLiquidityModel(true)
  }

  const proceedWithRemoveFunding = async(event) => {
    event.preventDefault();
    setShowRemoveLiquidityModel(false)
    beforeSend();
    const isValid = validate();
    if(isValid){
      try{
        await removeFunding();
      }catch(error){
        afterSend()  
      }
    }else{
      afterSend()
    }
  }

  const onLiquidityChange = (event) => {
    const liquidityToBeRemoved = event.target.value;
    const userLiquidityShares = amountSToB(getUserLiquidityShares())
    if(isUserLoggedIn && liquidityToBeRemoved > userLiquidityShares) return 0;

    setLiquidity(liquidityToBeRemoved)
  }
  
  return (
    <div>
      {isShowing && (
        <LiquidityBox>
          <form>
            <div className="text">{t('market_page.remove_liquidity')}</div>
            <div className="pbt" style={{fontSize:14, marginBottom:10}}>{t('market_page.share_you_can_remove')}: {strToFixed(amountSToB(getUserLiquidityShares()))}</div>
            <InputBoxWithMax
              value={liquidity}
              onChange={(e) => onLiquidityChange(e)}
              onClick={(e) => onMaxClicked(e)}
              maxItemName={t('share', {count: 2})}
            />
          </form>
        
          <Group>
            <Button 
              appearance="primary" 
              onClick={validateAndRemoveFunding} 
              disabled={disableAsyncButton(globalState)}
            >
              {showLoadingButton(globalState, actionName) ? t('market_page.removing') : t('market_page.remove_liquidity')}
            </Button>
          </Group>
        </LiquidityBox>
      )}

      {!isShowing && (
        <ToggleWrap>
          <button onClick={toggleShow}>{t('market_page.remove_liquidity')}</button>
        </ToggleWrap>
      )}

      {showRemoveLiquidityModel && (
        <Modal
          title={t('market_page.remove_liquidity_t_and_c_title')}
          align="center"
          close={() => setShowRemoveLiquidityModel(false)}
        >
          <div>
            <p>
              {t('market_page.remove_liquidity_terms_and_condition')}
            </p>
            <div className="d-flex align-center justify-content-center">
              <div style={{padding:10}}>
                <Button appearance="primary" size="sm" onClick={(e) => proceedWithRemoveFunding(e)}>{t('market_page.i_agree')}</Button>
              </div>
              <div style={{padding:10}}>
                <Button appearance="danger" size="sm" onClick={() => setShowRemoveLiquidityModel(false)}>{t('market_page.close_popup')}</Button>
              </div>
            </div>
          </div>          
         
        </Modal>
      )}

      {liquiditySuccessHash!='' && (
        <Modal
          title={t('transaction_hash')}
          align="center"
          close={() => setLiquiditySuccessHash('')}
        >
          <div>
            <p style={{wordWrap:'break-word', wordBreak: 'break-all'}}>
              {t('transaction_hash')}: {liquiditySuccessHash}
            </p>
            <a href={getChainBaseUrl(globalState.chainId) + `/tx/${liquiditySuccessHash}`} target="_blank">{t('visit_etherscan_to_view_transaction')}</a>
          </div>          
        </Modal>
      )}
    </div>
  )
};

export default RemoveLiquidity;

const LiquidityBox = styled.div`
  padding: 1rem 1.5rem;
  border-radius: 2px;
  // border: 1px solid #ada3e2;
  // background-color: ${theme.light};
  // margin-bottom: 20px;


  .text {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
  }
`;

const Group = styled.div`
  margin-top: 18px;
  margin-bottom: 5px;
`;

const ToggleWrap = styled.div`
  text-align: center;
  // border: 1px solid #ada3e2;
  // background-color: ${theme.light};
  // margin-bottom: 20px;

  button {
    color: #fff;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 18px;
    // text-decoration: underline;
    padding: .5em;
    background-color: transparent;

    &:active,
    &:focus {
      outline: none;
    }
  }
`;
